import React, { useEffect } from "react";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import { useCategorySeries } from "../../../hooks/useProducts";
import loaderIcon from "../../../images/icons/loader.svg";
import LazyImage from "../../common/LazyImage";

const ProductsSeries = () => {
  const { categoryId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { data, isLoading, isError } = useCategorySeries(categoryId); // получаем список серий для конкретной категории продуктов

  useEffect(() => {
    // Сбрасываем categoryName при изменении categoryId или устанавливаем после загрузки данных
    if (data?.category_name && data.category_id === parseInt(categoryId)) {
      // Устанавливаем pageTitle и categoryName после загрузки данных
      navigate(location.pathname, {
        replace: true,
        state: {
          ...location.state,
          pageTitle: data.category_name,
          categoryName: data.category_name,
        },
      });
    } else {
      // Сбрасываем categoryName при изменении categoryId или если данных еще нет
      navigate(location.pathname, {
        replace: true,
        state: {
          ...location.state,
          categoryName: null,
          pageTitle: null,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId, data, location.pathname, navigate]);

  if (isLoading) {
    return (
      <div className="loader">
        <img src={loaderIcon} alt="loader" />
      </div>
    );
  }

  if (isError) {
    return <div className="page-width">Ошибка загрузки списка серий</div>;
  }

  // Сортируем серии по полю sort
  const items = [...(data?.result || [])].sort(
    (a, b) => (a.sort ?? 0) - (b.sort ?? 0)
  );

  return (
    <div className="pump-series page-width_large">
      <div className="pump-series-grid">
        {items.map((series) => (
          <Link
            key={series.id}
            to={`/products/${categoryId}/${encodeURIComponent(series.name)}`}
            state={{
              ...location.state,
              categoryName: location.state?.categoryName,
              seriesName: series.name,
              seriesId: series.id,
            }}
            className="pump-series-card"
          >
            <div className="series-image-container">
              {series.image && (
                <LazyImage
                  src={series.image}
                  alt={series.name}
                  className="series-image"
                  maxWidth="120px"
                  maxHeight="180px"
                />
              )}
            </div>
            <div className="series-info">
              <h3>{series.name}</h3>
              {series.description && <p>{series.description}</p>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ProductsSeries;
